import {
  buildVorlageName,
  getVorlageCategory,
  getVorlageDisplayName,
  getVorlageSubsection,
  resolvePromptTargetMod,
} from "./vorlagenHelpers";
import { hasRichTextContent } from "./richTextHelpers";

export const validateNewVorlageInput = ({ name, befund, mod }) => {
  const isModalitaeten = String(mod || "").trim() === "Modalitäten";
  if (!String(name || "").trim()) return "Bitte Name eingeben.";
  if (!isModalitaeten && !hasRichTextContent(befund)) return "Befund darf nicht leer sein.";
  return "";
};

export const validateEditableVorlageInput = (prompt) => {
  const isModalitaeten = String(prompt?.mod || "").trim() === "Modalitäten";
  if (!prompt?.id) return "Ungültige Vorlage.";
  if (!String(prompt.name || "").trim()) return "Bitte Name eingeben.";
  if (!isModalitaeten && !hasRichTextContent(prompt.befund)) return "Befund darf nicht leer sein.";
  return "";
};

export const createNewVorlageEntry = ({
  newPromptMod,
  newPromptMrtTarget,
  newPromptSubsection,
  newPromptCategory,
  newPromptName,
  newPromptBefund,
  newPromptBeurteilung,
  createId,
  now,
}) => ({
  id: createId(),
  name: buildVorlageName({
    name: newPromptName,
    subsection: newPromptSubsection,
    category: newPromptCategory,
  }),
  mod: resolvePromptTargetMod(newPromptMod, newPromptMrtTarget),
  befund: String(newPromptBefund || "").trim(),
  beurteilung: String(newPromptBeurteilung || "").trim() || null,
  created_at: typeof now === "function" ? now() : Date.now(),
});

export const removeVorlageById = (list, id) =>
  (Array.isArray(list) ? list : []).filter((entry) => entry.id !== id);

export const normalizeVorlageForSave = (prompt) => ({
  ...prompt,
  name: buildVorlageName({
    name: getVorlageDisplayName(prompt),
    subsection: prompt?.subsection || getVorlageSubsection(prompt),
    category: prompt?.category || getVorlageCategory(prompt),
  }),
  beurteilung: prompt?.beurteilung || null,
});

export const updateVorlageById = (list, prompt) => {
  const normalized = normalizeVorlageForSave(prompt);
  return (Array.isArray(list) ? list : []).map((entry) => (
    entry.id === normalized.id
      ? {
          ...entry,
          name: normalized.name,
          subsection: normalized.subsection,
          mod: normalized.mod,
          befund: normalized.befund,
          beurteilung: normalized.beurteilung,
          category: normalized.category,
        }
      : entry
  ));
};
